import './index.sass';
import './works-preview/index.sass';
import initAsideFilters from './aside-filters';
import axios from "axios";

export default () => {
  $('.aside-filters').length && initAsideFilters();
  const $root = $('.users');
  const $btn = $('.js-users-card-more');

  $btn.on('click', function (e) {
    e.preventDefault();
    const $el = $(this);
    initAjax($el);
  });

  const initAjax = ($el) => {
    if(!$el.data('url')) $el.hide();
    $root.find('.users__list').append('<div class="list-loader"></div>');
    axios.get($el.data('url'), {
      headers: { 'Accept': 'application/json' }
    }).then((response) => {
      const resp = response;
      const $illustrations = $(resp.data.users);
      const url = resp.data.url;
      if(url) {
        $el.data('url', url);
      } else {
        $el.remove();
      }
      $root.find('.users__list').append($illustrations);
      $root.find('.list-loader').remove();
      if(resp.data.pagination) {
        $root.find('.users__pagination').html(resp.data.pagination);
      }
    }).catch((error) => {
      console.log(error.response)
    });
  }
}
